export default "__VITE_ASSET__T1FFKnE$__"